<template>
  <div class="booking-management">
    <div class="booking-management-action">
      <el-button
        type="danger"
        icon="el-icon-edit-outline"
        @click="goPage({name: 'BookingAddNotes'})"
      >通知客服</el-button>
      <el-button
        type="danger"
        icon="el-icon-edit"
        @click="goPage({
          name: 'BookingOrderManage',
          params: {
            type: 'edit',
          }
        })"
      >修改预约</el-button>
      <el-button
        type="danger"
        icon="el-icon-document-delete"
        @click="goPage({
          name: 'BookingOrderManage',
          params: {
            type: 'cancel',
          }
        })"
      >取消预约</el-button>
    </div>

  </div>
</template>

<script>
export default {
  methods: {
    goPage({ name, params = {} }) {
      const query = this.$route.query;
      this.$router.push({
        name,
        query: {
          ...query,
          ...params,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.booking-management {
  padding: 20px;
}
.booking-management-action {
  display: flex;
  flex-direction: column;
  align-items: center;
  .el-button {
    margin-left: 0;
    margin-bottom: 20px;
    width: 70%;
  }
}
</style>